/* Show product details below the form; load their media near the viewport. */
(function () {
  'use strict';
  var source = document.getElementById('codProductDescription');
  var target = document.getElementById('descriptionSection');
  if (!source || !target) return;
  var content = source.content.cloneNode(true);
  // Merchant descriptions can retain old shipping copy. Show it on the receipt.
  // Only delivery phrases match: «توصيل بلوتوث» (connection) and «شحن سريع»
  // (battery charging) are product features and stay.
  var shippingCopy = [
    /(?:التوصيل|توصيل|الشحن|شحن)\s*(?:ال)?(?:مجاني|مجانا|مجاناً|بالمجان|سريع\s+(?:لجميع|لكل|إلى|الى|في))/,
    /(?:التوصيل|توصيل|الشحن|شحن)\s+(?:متوفر\s+)?(?:إلى|الى|ل|لـ|لكل|لجميع|في|عبر|داخل)?\s*(?:كامل|جميع|كل|كافة)?\s*(?:\d+\s*)?(?:ال)?(?:ولايات|ولاية|التراب|الوطن|الجزائر|المدن)/,
    /(?:سعر|ثمن|تكلفة|تكاليف|رسوم|مصاريف|مدة|خدمة|أجل|آجال)\s+(?:ال)?(?:توصيل|شحن)/,
    /(?:التوصيل|توصيل)\s+(?:إلى|الى|حتى|ل)\s*(?:باب\s*)?(?:ال)?(?:منزل|بيت|دار|مكتب|باب)/,
    /(?:التوصيل|الشحن)\s+(?:خلال|في\s+ظرف|في\s+مدة|بين)\s*\d/,
    /(?:نوصل|نوصلو|يوصلك|توصلك|يصلك|يوصلولك)/,
    /\b(?:livraison|shipping|delivery|exp[ée]dition)\b/i
  ];
  function isShippingCopy(text) { return shippingCopy.some(function (pattern) { return pattern.test(text); }); }
  content.querySelectorAll('script,style,object,embed').forEach(function (node) { node.remove(); });
  var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
  var removals = [], node;
  while ((node = walker.nextNode())) {
    if (!isShippingCopy(node.textContent)) continue;
    var block = node.parentElement && node.parentElement.closest('p,li,h1,h2,h3,h4,h5,h6,figcaption');
    removals.push(block || node);
  }
  removals.forEach(function (item) { item.remove(); });

  var pending = new Map();
  function deferMedia(element, nodes, attributes) {
    var saved = [];
    nodes.forEach(function (media) {
      attributes.forEach(function (name) {
        if (!media.hasAttribute(name)) return;
        var value = media.getAttribute(name);
        saved.push({node: media, name: name, value: value});
        media.setAttribute('data-cod-' + name, value);
        media.removeAttribute(name);
      });
    });
    if (saved.length) {
      element.setAttribute('data-cod-lazy', '');
      pending.set(element, saved);
    }
  }
  function activateMedia(element) {
    var saved = pending.get(element);
    if (!saved) return;
    saved.forEach(function (attr) {
      attr.node.setAttribute(attr.name, attr.value);
      attr.node.removeAttribute('data-cod-' + attr.name);
    });
    element.removeAttribute('data-cod-lazy');
    pending.delete(element);
    if (element.tagName === 'VIDEO') element.load();
  }

  content.querySelectorAll('img').forEach(function (img) {
    img.loading = 'lazy';
    img.decoding = 'async';
    if (!img.getAttribute('alt')) img.alt = '';
    // Size a Shopify CDN image without changing its format or a GIF's URL.
    try {
      var url = new URL(img.getAttribute('src'), location.href);
      if (url.hostname === 'cdn.shopify.com' && !/\.gif$/i.test(url.pathname)) {
        url.searchParams.set('width', '800');
        img.src = url.href;
      }
    } catch (e) {}
    var picture = img.closest('picture');
    var nodes = picture ? Array.from(picture.querySelectorAll('source')).concat(img) : [img];
    deferMedia(img, nodes, ['srcset', 'src']);
  });
  content.querySelectorAll('iframe').forEach(function (frame) {
    frame.loading = 'lazy';
    if (!frame.title) frame.title = 'فيديو المنتج';
    deferMedia(frame, [frame], ['srcdoc', 'src']);
  });
  content.querySelectorAll('video').forEach(function (video) {
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.controls = true;
    video.playsInline = true;
    deferMedia(video, Array.from(video.querySelectorAll('source')).concat(video), ['src', 'poster']);
  });
  target.appendChild(content);
  source.remove();

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activateMedia(entry.target);
        observer.unobserve(entry.target);
      });
      if (!pending.size) observer.disconnect();
    }, {rootMargin: '150px 0px'});
    pending.forEach(function (saved, element) { observer.observe(element); });
  } else {
    // Older browsers still display everything, with native lazy loading where available.
    pending.forEach(function (saved, element) { activateMedia(element); });
  }
})();
